exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
exports.i(require("-!../../../node_modules/css-loader/dist/cjs.js!vue-select/dist/vue-select.css"), "");

// Module
exports.push([module.id, "/*\r\n  Force 'normal' styling for v-select\r\n */\n.v-select {\n  padding: 0; }\n  .v-select:not(.vs--open) .vs__selected-options .vs__search {\n    height: 0;\n    border: 0;\n    margin: 0; }\n  .v-select .vs__dropdown-toggle {\n    height: 100%;\n    border: 0; }\n  .v-select.form-control {\n    min-height: 34px; }\n    .v-select.form-control .vs__dropdown-toggle {\n      min-height: 34px; }\n", ""]);

